module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/203-sahrawi-arab-democratic-republic-7fa24d48fe2eeacc363cdd98a92d0783.svg";